import {FeaturesFormGroup, PropertyListingTab} from './../property-listing.component';
import {CommonModule} from '@angular/common';
import {Component, Input, OnInit, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {Advisor, ParkingType, StorageType} from 'src/app/services/portal-api.service';
import {Subject} from 'rxjs';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import { ChangeContext, NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { ApartmentOptionButton, FloorTypeOptions, ApartmentOptionsComponent } from '../../property-upload-wizard/appartment-options/apartment-options.component';
export class SelectTileOption {
  name: string;
  value: any;
  enabled: boolean;
  icon?: string;

  constructor(name: string, value: any, enabled: boolean = true, icon: string = '') {
      this.name = name;
      this.value = value;
      this.enabled = enabled;
      this.icon = icon;
  }
}
  export enum FeaturesTileOptions
  {
      Elevator,
      Alarm,
      SafetyDoor,
      Garden,
      Pool,
      InternalStaircase,
      Gym,
      SeaView,
      GreatView,
      AirConditioning,
      FirePlace
  }

@Component({
  selector: 'app-features',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, TranslocoDirective, TranslocoPipe, NgxSliderModule, ApartmentOptionsComponent],
  templateUrl: './features.component.html',
  styleUrl: './features.component.css'
})
export class FeaturesComponent implements OnInit {
  @Input() featuresFormGroup: FormGroup<FeaturesFormGroup> = new FormGroup(new FeaturesFormGroup());
  @Input() advisor: Advisor | undefined;

  @Output() onNextTab: Subject<PropertyListingTab> = new Subject();
  public selectedFloorType: FloorTypeOptions | undefined;
  public parkingType = ParkingType;
  public propertyListingTab = PropertyListingTab;
  public storageType = StorageType;
  public showApartmentFloortype:boolean = false;

  public storageArea: number = 20;
  
  public storageAreaSliderOptions: Options = {
    floor: 20,
    ceil: 800,
    step: 1,
    showSelectionBar: true
  };
  public featuresTileOptions = [
    new SelectTileOption("internalStaircase", FeaturesTileOptions.InternalStaircase, false, 'icon-stairs'),
    new SelectTileOption("hasGarden", FeaturesTileOptions.Garden, false, 'icon-garden'),
    new SelectTileOption("hasPool", FeaturesTileOptions.Pool, false, 'icon-pool'),
    new SelectTileOption("hasFirePlace", FeaturesTileOptions.FirePlace, false, 'icon-fireplace'),
    new SelectTileOption("hasSafetyDoor", FeaturesTileOptions.SafetyDoor, false, 'icon-safety-door'),
    new SelectTileOption("hasElevator", FeaturesTileOptions.Elevator, false, 'icon-elevator'),
    new SelectTileOption("hasGym", FeaturesTileOptions.Gym, false, 'icon-gym'),
    new SelectTileOption("hasAirconditioning", FeaturesTileOptions.AirConditioning, false, 'icon-air-conditioning'),
    new SelectTileOption("hasSeaView", FeaturesTileOptions.SeaView, false, 'icon-sea-view'),
    new SelectTileOption("hasAlarm", FeaturesTileOptions.Alarm, false, 'icon-alarm'),
    new SelectTileOption("hasGreatView", FeaturesTileOptions.GreatView, false, 'icon-great-views'),
  ]

  ngOnInit(): void {
    this.storageArea =  this.featuresFormGroup.controls?.storageArea.value;
    this.showApartmentFloortype = this.featuresFormGroup.controls.floor.value == -1
    this.selectedFloorType = this.featuresFormGroup.controls.floorType.value;
  }

  public navigateToTab(tab: PropertyListingTab) {
    this.onNextTab.next(tab);
  }

  public filterButtons(buttons:ApartmentOptionButton[]){
    return buttons.filter(x=>x.id == FloorTypeOptions.Basement || x.id == FloorTypeOptions.SemiBasement)
  }

  toggleFeature(feature: string, event: Event) {
    const checkbox = event.target as HTMLInputElement;
    (this.featuresFormGroup.controls.amenities.controls as any)?.[feature].setValue(checkbox.checked);
  }

  isCheckedFeature(feature: string) : boolean {
    return (this.featuresFormGroup.controls.amenities.controls as any)?.[feature]?.value ?? false
  }

  apartmentFloorTypeSelected(apartmentFloorType: ApartmentOptionButton) {
    const floorType = this.featuresFormGroup.controls.floor.value == -1 ? FloorTypeOptions[apartmentFloorType.id] : null
    this.featuresFormGroup.controls.floorType.patchValue(floorType)
  }

  floorValue(number: number) {
    let currentFloorValue = this.featuresFormGroup.controls.floor.value ?? 0;
    if (currentFloorValue === -1 && number < 0) {
      return;
    }
    const setFloor = currentFloorValue + number
    if(currentFloorValue + number < 0){
      this.showApartmentFloortype = true
    }else{
      this.showApartmentFloortype = false
    }
    this.featuresFormGroup.controls.floor.patchValue(setFloor);
    if(setFloor > -1){
      this.selectedFloorType = undefined
      this.featuresFormGroup.controls.floorType.patchValue(null)
    }
  }

  public onStorageTypeClick(storageType: StorageType): void {
    var index = this.featuresFormGroup.controls.storageType?.value?.indexOf(storageType.toString());
    let storageTypeVal = this.featuresFormGroup?.controls?.storageType?.value;

    if (index === -1) {
      storageTypeVal?.push(storageType.toString());
    } else if (index !== -1) {
      storageTypeVal?.splice(index, 1);
    }
    this.featuresFormGroup.controls.storageType.patchValue(storageTypeVal);
  }

  public onParkingTypeClick(parkingType: ParkingType): void {
    var index = this.featuresFormGroup.controls.parkingType?.value?.indexOf(parkingType.toString());
    let parkingTypeVal = this.featuresFormGroup?.controls?.parkingType?.value;

    if (index === -1) {
      parkingTypeVal?.push(parkingType.toString());
    } else if (index !== -1) {
      parkingTypeVal?.splice(index, 1);
    }
    this.featuresFormGroup.controls.parkingType.patchValue(parkingTypeVal);
  }

  onStorageSizeSliderChange(changeContext: ChangeContext) {
    this.featuresFormGroup.patchValue({ storageArea: changeContext.value ?? null})
  }
}
